var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"sort-panel__wrap",attrs:{"data-test-id":"sortBtn","icon":""},nativeOn:{"click":function($event){return _vm.changeSort()}}},[_c('v-img',{attrs:{"contain":"","height":"12","src":_vm.sortTypeIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }